// Home
// Healthcare Institutions
import iconMenuHciActive from '@/assets/menu/icon_menu_active_hci.svg?url';
import iconMenuPatientEngagementLifecycleActive from '@/assets/menu/icon_menu_active_patient_engagement.svg?url';
import iconMenuPatientListsActive from '@/assets/menu/icon_menu_active_patient_lists.svg?url';
import iconMenuReportingActive from '@/assets/menu/icon_menu_active_reporting.svg?url';
import iconMenuHciDefault from '@/assets/menu/icon_menu_default_hci.svg?url';
import iconMenuPatientEngagementLifecycleDefault from '@/assets/menu/icon_menu_default_patient_engagement.svg?url';
import iconMenuPatientListsDefault from '@/assets/menu/icon_menu_default_patient_lists.svg?url';
import iconMenuReportingDefault from '@/assets/menu/icon_menu_default_reporting.svg?url';
import iconMenuHciHover from '@/assets/menu/icon_menu_hover_hci.svg?url';
// Patinet Engagement Lifecycle
import iconMenuatientEngagementLifecycleHover from '@/assets/menu/icon_menu_hover_patient_engagement.svg?url';
// Patient Lists
import iconMenuPatientListsHover from '@/assets/menu/icon_menu_hover_patient_lists.svg?url';
// Reporting
import iconMenuReportingHover from '@/assets/menu/icon_menu_hover_reporting.svg?url';

import iconMenuHomeActive from '../../../assets/menu/icon_menu_active_home.svg?url';
import iconMenuHomeDefault from '../../../assets/menu/icon_menu_default_home.svg?url';
import iconMenuHomeHover from '../../../assets/menu/icon_menu_hover_home.svg?url';

type sideNavigationMenuConfigObject = {
	children?: sideNavigationMenuConfigObject[];
	icon: {
		iconDefault: string;
		iconActive: string;
		iconHover: string;
	};
	link: string;
	label: string;
	testId: string;
};

export const sideNavigationMenuConfig: sideNavigationMenuConfigObject[] = [
	{
		icon: {
			iconDefault: iconMenuHomeDefault,
			iconActive: iconMenuHomeActive,
			iconHover: iconMenuHomeHover,
		},
		label: 'Home',
		link: '/',
		testId: 'home',
	},
	{
		icon: {
			iconDefault: iconMenuHciDefault,
			iconActive: iconMenuHciActive,
			iconHover: iconMenuHciHover,
		},
		label: 'Healthcare Institutions',
		link: '/health-care-institution',
		testId: 'health-care-institution',
	},
	{
		children: [
			{
				icon: {
					iconDefault: '',
					iconActive: '',
					iconHover: '',
				},
				label: 'Patient Assignment',
				link: '/patient-engagement-lifecycle/patient-assignment',
				testId: 'patient-assignment',
			},
			{
				icon: {
					iconDefault: '',
					iconActive: '',
					iconHover: '',
				},
				label: 'Patient Progress',
				link: '/patient-engagement-lifecycle/patient-progress',
				testId: 'patient-progress',
			},
			{
				icon: {
					iconDefault: iconMenuPatientListsDefault,
					iconActive: iconMenuPatientListsActive,
					iconHover: iconMenuPatientListsHover,
				},
				label: 'Patient Lists',
				link: '/patient-engagement-lifecycle/patient-lists',
				testId: 'patient-lists',
			},
			{
				icon: {
					iconDefault: iconMenuReportingDefault,
					iconActive: iconMenuReportingActive,
					iconHover: iconMenuReportingHover,
				},
				label: 'Reporting',
				link: '/patient-engagement-lifecycle/reporting',
				testId: 'reporting',
			},
		],
		icon: {
			iconDefault: iconMenuPatientEngagementLifecycleDefault,
			iconActive: iconMenuPatientEngagementLifecycleActive,
			iconHover: iconMenuatientEngagementLifecycleHover,
		},
		label: 'Patient Engagement Lifecycle',
		link: '/patient-engagement-lifecycle',
		testId: 'patient-engagement-lifecycle',
	},
];
